import { ROOT_PAGE, getCoachPageUrl } from 'constants/pages';
import {
  CoachAvailabilityStatusesEnum,
  CoachReviewTypesEnum,
  Reviews,
} from 'types/generated/client';
import Home from 'svg/Home';
import { Coach, ReviewTabsEnum, SortCriterionType } from './types';

export const generateBreadcrumbs = ({
  isForJsonLd,
  coachName,
  coachSlug,
}: {
  isForJsonLd?: boolean;
  coachName: string;
  coachSlug: string;
}) => {
  return {
    ui: isForJsonLd
      ? []
      : [
          {
            label: <Home className="w-4" />,
            url: ROOT_PAGE,
          },
          {
            label: coachName || '',
            url: getCoachPageUrl(coachSlug || ''),
          },
        ],
    jsonLd: [
      {
        name: 'Home',
        id: ROOT_PAGE,
      },
      {
        name: `${coachName} Pickleball Coach` || '',
        id: getCoachPageUrl(coachSlug || ''),
      },
    ].map((item) => ({
      ...item,
      id: `${process.env.APP_URL}${item.id}`,
    })),
  };
};

export const calculateCategoryRating = (category: CoachReviewTypesEnum, reviews: Reviews[]) => {
  const filteredReviews = reviews.filter((review) => review.type === category);
  if (filteredReviews.length === 0) return 0;
  const totalRating = filteredReviews.reduce((acc, review) => acc + review.rating, 0);
  return (totalRating / filteredReviews.length).toFixed(1);
};
export const getFilteredReviews = (
  reviews: Reviews[],
  activeReviewTab: ReviewTabsEnum,
  sortCriterion: SortCriterionType,
): Reviews[] => {
  let filtered = reviews;
  if (activeReviewTab === ReviewTabsEnum.OnCourt) {
    filtered = reviews.filter((review) => review.type === CoachReviewTypesEnum.Court);
  } else if (activeReviewTab === ReviewTabsEnum.Remote) {
    filtered = reviews.filter((review) => review.type === CoachReviewTypesEnum.Remote);
  }

  return filtered.toSorted((a, b) => {
    if (sortCriterion.value === 'high') return b.rating - a.rating;
    if (sortCriterion.value === 'low') return a.rating - b.rating;
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
};

export const sortCriterions: SortCriterionType[] = [
  {
    label: 'Most recent',
    value: 'most',
  },
  {
    label: 'Highest rating',
    value: 'high',
  },
  {
    label: 'Lowest rating',
    value: 'low',
  },
];

export const getShouldShowContactCoach = (coach: Coach) => {
  if (!coach) return false;

  const hasPaymentEnabled = coach.stripeMerchantChargesEnabled || false;
  const hasActiveAvailability = coach.coachAvailability.some(
    (availability) => availability.status === CoachAvailabilityStatusesEnum.Active,
  );

  return !hasPaymentEnabled || !hasActiveAvailability;
};
